// Pure open/closed/waitlist decision for public registration. Extracted from
// RegisterApp so it's unit-testable and the page + tests share ONE code path.
// Waitlisted entries never count toward the cap.
export function registrationGate(info = {}, regs = {}, nowMs = Date.now()) {
  const registeredCount = Object.keys(regs).filter((k) => !regs[k]?.waitlisted).length
  const max = Number(info.maxTeams) || null
  const status = info.registrationStatus || 'open'
  const deadline = info.entryDeadline ? new Date(info.entryDeadline) : null
  const deadlinePassed = deadline ? nowMs > (new Date(deadline).getTime() + 24 * 60 * 60 * 1000) : false
  const opens = info.registrationOpens ? new Date(info.registrationOpens) : null
  const notYetOpen = opens ? nowMs < opens.getTime() : false
  const full = !!(max && registeredCount >= max)
  const waitlistOn = !!info.waitlistEnabled
  const closed = status === 'closed' || deadlinePassed || notYetOpen || (full && !waitlistOn)
  // Full + waitlist on + not otherwise closed → the form stays open, flagged.
  const waitlisted = full && waitlistOn && !closed
  return { registeredCount, max, full, closed, waitlisted, notYetOpen, deadlinePassed, status, opens }
}
